import QuotesCarousel from "components/organisms/common/QuotesCarousel"
import useTranslations from "hooks/useTranslations"
import Statistics from "components/organisms/schools/Statistics"
import client1 from "images/influencers/clients/client-1.jpg"
import client2 from "images/influencers/clients/client-2.jpg"
import client3 from "images/influencers/clients/client-3.jpg"
import client4 from "images/influencers/clients/client-4.jpg"
import client5 from "images/influencers/clients/client-5.jpg"
import client6 from "images/influencers/clients/client-6.jpg"
import client7 from "images/influencers/clients/client-7.jpg"

export default function QuotesCarouselSchools() {
  const {
    schoolCaseQuoteTitle,
    schoolCaseQuote1Title,
    schoolCaseQuote1Text,
    schoolCaseQuote2Title,
    schoolCaseQuote2Text,
    schoolCaseQuote3Title,
    schoolCaseQuote3Text,
  } = useTranslations()

  const slidesData = [
    {
      title: schoolCaseQuote1Title,
      text: schoolCaseQuote1Text,
      // inboundLink: getCaseLink(locale, "stalking"),
      picture: client6,
    },
    {
      title: schoolCaseQuote2Title,
      text: schoolCaseQuote2Text,
      // inboundLink: getCaseLink(locale, "defaming"),
      picture: client5,
    },
    {
      title: schoolCaseQuote3Title,
      text: schoolCaseQuote3Text,
      // inboundLink: getCaseLink(locale, "doxxing"),
      picture: client3,
    },
  ]

  return (
    <QuotesCarousel slides={slidesData} bgColor="green" sliderBgColor="yellow">
      <Statistics />
    </QuotesCarousel>
  )
}
